import { render } from "./Principles.vue?vue&type=template&id=8d62c42e&scoped=true"
import script from "./Principles.vue?vue&type=script&lang=js"
export * from "./Principles.vue?vue&type=script&lang=js"

import "./Principles.vue?vue&type=style&index=0&id=8d62c42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d62c42e"]])

export default __exports__